import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29.707 2.293a1 1 0 0 1 0 1.414L26.414 7l.667.667a4.005 4.005 0 0 1 .87 4.367 4 4 0 0 1-.87 1.299L23.914 16.5l.293.293a1 1 0 0 1-1.414 1.414l-.997-.997-.003-.003-.003-.003-6.994-6.994-.003-.003-.003-.003-.997-.997a1 1 0 0 1 1.414-1.414l.293.293 3.167-3.167a4 4 0 0 1 5.666 0l.667.667 3.293-3.293a1 1 0 0 1 1.414 0m-4.038 9.624L22.5 15.086 16.914 9.5l3.17-3.17a2 2 0 0 1 2.833 0l2.752 2.753a2 2 0 0 1 0 2.834M10.21 14.796l-.003-.003-.003-.003-.997-.997a1 1 0 0 0-1.414 1.414l.293.293-3.167 3.167a4 4 0 0 0 0 5.666l.667.667-3.293 3.293a1 1 0 1 0 1.414 1.414L7 26.414l.667.667a4 4 0 0 0 5.666 0l3.167-3.167.293.293a1 1 0 0 0 1.414-1.414l-.997-.997-.003-.003-.003-.003-.79-.79 2.293-2.293a1 1 0 0 0-1.414-1.414L15 19.586 12.414 17l2.293-2.293a1 1 0 0 0-1.414-1.414L11 15.586zm-.71 2.118-3.17 3.17a2 2 0 0 0 0 2.833h.002l2.751 2.752a2 2 0 0 0 2.834 0l3.169-3.169-.793-.793-4-4z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconIntegrations = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconIntegrations);
export default Memo;
